import { DatabaseDAO } from "@/services/base/DatabaseDAO";

class AccountsDAO extends DatabaseDAO {

}

export default new AccountsDAO();
